import React from 'react';
import { Icon } from '../../../../shared/components/Icon';
export const SPLogo = ({ appIconSource = 'SPLogo' }) => (React.createElement(Icon, { source: appIconSource, svgStyle: {
        width: '140px',
        height: '60px',
    } }));
//# sourceMappingURL=SPLogo.js.map